import { post, get, put, _delete } from '@common/module/httpRequest';
import { runInAction } from 'mobx'; 
import TimelineModel from '@model/TimelineModel';

class TimelineService {
    async load(customerId, timelineType=null) {
        let path=`/business/${customerId}/timeline?timelineType=${timelineType}`;
        if(!timelineType) {
            path=`/business/${customerId}/timeline`;
        }
        const res = await get(path);
        TimelineModel.setNormalTimeLines(res.data.normalTimeLines);
        TimelineModel.setPinnedTimeLines(res.data.pinnedTimeLines);
    }
    async saveMessage(param, customerId, activeTab) {
        const res = await post(`/business/${customerId}/timeline`, param);
        await this.load(customerId, activeTab);
    }
    async pin(customerId, timelineId, pinned, activeTab) {
        const res = await put(`/business/${customerId}/timeline/${timelineId}?pinned=${pinned}`);
        await this.load(customerId, activeTab);
    }
    async delete(customerId, timelineId, activeTab) {
        const res = await _delete(`/business/${customerId}/timeline/${timelineId}`);
        await this.load(customerId, activeTab);
    }
}
export default new TimelineService();